module.exports = __webpack_public_path__ + "static/img/5623_phase_function_Paper_PointsHejduk_Prediction.b6106a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5623_phase_function_Paper_PointsHejduk_Prediction.png
// module id = eXrD
// module chunks = 0